import { render, staticRenderFns } from "./BannerFooter.vue?vue&type=template&id=4293a11c"
import script from "./BannerFooter.vue?vue&type=script&lang=js"
export * from "./BannerFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports